import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2 bg-blue-4 p-4 text-darkGray-1 w-full"
}
const _hoisted_2 = { class: "grid grid-cols-3 gap-x-2" }
const _hoisted_3 = {
  key: 0,
  class: "p-1 text-white col-span-full place-self-end text-xs"
}
const _hoisted_4 = { class: "grid grid-cols-3 gap-x-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-1 text-white col-span-full place-self-end text-xs"
}
const _hoisted_6 = { class: "grid grid-cols-3 gap-x-2" }
const _hoisted_7 = {
  key: 0,
  class: "p-1 text-white text-xs col-span-full place-self-end"
}
const _hoisted_8 = { class: "grid grid-cols-3 gap-x-2" }
const _hoisted_9 = {
  key: 0,
  class: "p-1 text-white col-span-full place-self-end text-xs"
}
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex gap-2" }

import { ref, reactive } from "vue";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import { computed } from "@vue/reactivity";


export default /*@__PURE__*/_defineComponent({
  __name: 'SsnAgeInPeriods',
  props: {
    period: {},
    index: {}
  },
  emits: ["removePeriod", "savePeriod"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const period = reactive(props.period);

const isEditing = ref(true);

const messages = {
  required: "Fältet är obligatoriskt",
  startDateIsBeforeEndDate: "Datumet kan inte vara före periodens startdatum",
  endDateIsAfterStartDate: "Datumet kan inte vara efter periodens slutdatum",
  ageIsHigherThanMaxAge: "Åldern kan inte vara lägre än maxåldern",
  ageIsLowerThanMinAge: "Åldern kan inte vara högre än minåldern",
  ageIsPositive: "Åldern kan inte vara negativ",
};

const rules = computed(() => {
  return {
    periodStart: {
      required,
      endDateIsAfterStartDate: helpers.withMessage(
        messages.endDateIsAfterStartDate,
        (value: string) => {
          const date = new Date(value);
          const endDate = new Date(period.periodEnd);
          return date <= endDate;
        }
      ),
    },
    periodEnd: {
      required,
      startDateIsBeforeEndDate: helpers.withMessage(
        messages.startDateIsBeforeEndDate,
        (value: string) => {
          const date = new Date(value);
          const startDate = new Date(period.periodStart);
          return date >= startDate;
        }
      ),
    },
    ageLow: {
      required,
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsLowerThanMinAge: helpers.withMessage(
        messages.ageIsLowerThanMinAge,
        (value: number) => {
          return value <= period.ageHigh;
        }
      ),
    },
    ageHigh: {
      required,
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsHigherThanMaxAge: helpers.withMessage(
        messages.ageIsHigherThanMaxAge,
        (value: number) => {
          return value >= period.ageLow;
        }
      ),
    },
  };
});

const v$ = useValidate(rules, period);

const validate = () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    return true;
  } else {
    return false;
  }
};

const emit = __emit;

const removePeriod = (index: number) => {
  emit("removePeriod", index);
};

const savePeriod = () => {
  if (!validate()) {
    return;
  }
  isEditing.value = false;
  emit("savePeriod", period, props.index);
};

return (_ctx: any,_cache: any) => {
  return (isEditing.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Periodens start ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["appearance-none border-2 border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-200", { 'border-2 border-red-2': _unref(v$).periodStart.$error }]),
            placeholder: "Ange periodens start",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period.periodStart) = $event))
          }, null, 2), [
            [_vModelText, period.periodStart]
          ]),
          (_unref(v$).periodStart.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(v$).periodStart.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Periodens slut ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["appearance-none border-2 border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-200", { 'border-2 border-red-2': _unref(v$).periodEnd.$error }]),
            placeholder: "Ange periodens slut",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((period.periodEnd) = $event))
          }, null, 2), [
            [_vModelText, period.periodEnd]
          ]),
          (_unref(v$).periodEnd.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(v$).periodEnd.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Lägsta ålder vid periodens start ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["appearance-none border-2 border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-200", { 'border-2 border-red-2': _unref(v$).ageLow.$error }]),
            placeholder: "Ange ålder",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period.ageLow) = $event))
          }, null, 2), [
            [_vModelText, period.ageLow]
          ]),
          (_unref(v$).ageLow.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(v$).ageLow.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Högsta ålder vid periodens slut ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["appearance-none border-2 border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-200", { 'border-2 border-red-2': _unref(v$).ageHigh.$error }]),
            placeholder: "Ange ålder",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((period.ageHigh) = $event))
          }, null, 2), [
            [_vModelText, period.ageHigh]
          ]),
          (_unref(v$).ageHigh.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(v$).ageHigh.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = () => savePeriod()),
            class: "bg-gradient-to-t from-orange-1 from-10% via-orange-1.5 via-45% to-orange-2.5 to-80% disabled:from-gray-1 disabled:to-gray-3 text-white border-none hover:from-orange-1.5 hover:to-orange-4 rounded-md px-3 py-1"
          }, " Spara "),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = () => removePeriod(props.index)),
            class: "bg-gradient-to-t from-red-700 to-red-2 hover:from-red-600 hover:to-red-3 text-sm rounded-md text-white px-3 py-1"
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
          ]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        _createElementVNode("p", null, " Minst " + _toDisplayString(period.ageLow) + " år fyllda " + _toDisplayString(period.periodStart) + " & Max " + _toDisplayString(period.ageHigh) + " år fyllda " + _toDisplayString(period.periodEnd) + ". ", 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (isEditing.value = !isEditing.value)),
            class: "bg-white text-sm rounded-lg text-darkGray-1 px-3 py-1"
          }, " Redigera "),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = () => removePeriod(props.index)),
            class: "bg-red-2 text-sm rounded-lg text-white px-3 py-1"
          }, " Ta bort ")
        ])
      ]))
}
}

})